import { appSettings } from '..';
import { EmployeeScheduleRequest } from '../shared/models';
import { EmployeeData } from '../shared/models/EmpDetails';
import BaseApiClient from './BaseApi';


export class EmpApi extends BaseApiClient {

    public static scopes: string[] = [
        'User.Read',
    ];

    public static auth(enabled?: boolean) {
        const authenticated = (enabled === undefined) ? true : enabled;
        return new this(authenticated);
    }

    protected constructor(authenticated?: boolean) {
        const { calloutApi } = appSettings;
        super(calloutApi.callout_api_host, authenticated);
    }

    public GetEmpDetails(employeeId: string, emailid: string): Promise<EmployeeData> {
        return this.__get<EmployeeData>(this.baseUrl + '/Employee/GetEmployeeSchedule?EmployeeNumber='+employeeId+'&EmailId='+emailid, EmpApi.scopes,undefined);
    }   

    public updateEmployeeSchedule(employeeScheduleRequest: EmployeeScheduleRequest): Promise<any> {
        return this._post<any>(this.baseUrl + '/Employee/UpdateEmployeeSchedule', employeeScheduleRequest, EmpApi.scopes);
    }
}